module.exports = __webpack_public_path__ + "img/navertv_logo_menu_m.56d0dfc4.png";